import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

export default function RadioList({ options, checked, setChecked }) {
  const handleChange = (event) => {
    setChecked([event.target.value]);
  };
  return (
    <FormControl>
      <RadioGroup
        aria-label="options"
        value={checked?.[0] ?? ""}
        onChange={handleChange}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.id}
            value={option.id}
            control={<Radio color="primary" />}
            label={option.title}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
